import React from "react";
import { Modal } from "react-bootstrap";
import alrajhibank_header from "assets/images/alrajhibank_header.svg";
import useStore from "stores/Store";

const SecurityTips = () => {
  const { showTips, setShowTips } = useStore();

  return (
    <Modal show={showTips} onHide={() => setShowTips(false)} centered size="lg">
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body className="ping text-grey-color pt-0">
        <div className="d-flex flex-column gap-4 px-3">
          <img src={alrajhibank_header} width="100%" alt="alrajhi_bank_app" />
          <div>
            <p className="fw-bold">
              Attention: Beware of fake alrajhi bank Malaysia website and
              emails!
            </p>
            <p>
              Please be aware that there exists a cloned and copied Al Rajhi
              Bank Website as well as emails created for the purpose of
              deceiving unwary customers and members of the public. This fake
              site and emails have absolutely no affiliation with alrajhi bank
              Malaysia whatsoever and have been created with malevolent and
              impure intentions.
            </p>
            <br />
            <p>
              Do not fall prey to online scams and do not be a victim. Our
              customers are our top priority. Your banking safety and security
              is of utmost concern to us. As we continue to investigate these
              fraudulent violations of our privacy as well as our customer's
              rights, do take heed of thefollowing precautionary measures and
              security tips.
            </p>
            <br />
            <p className="fw-bold">
              Protect your online banking experience with these security tips:
            </p>
            <p>
              alrajhi bank Malaysia NEVER sends out emails over matters
              regarding security or your account information. Please do not
              click any links sent via email from alrajhi bank Malaysia or from
              any party claiming to be affiliated with the bank.
            </p>
            <br />
            <p>
              Remember to always manually type{" "}
              <a href="https://www.alrajhibank.com.my">
                https://www.alrajhibank.com.my
              </a>{" "}
              into your internet browser for a secure online banking experience.
              Other clear indications that you are surfing the official Al Rajhi
              Bank site are the URL and the official alrajhi bank Malaysia
              masthead.
              <br />
              Check account balances, statements on a regular basis in order to
              detect any unauthorised transactions, error or discrepancy.
            </p>
            <br />
            <p>
              Please notify the Bank immediately for any unauthorised
              transaction via the following channels:
            </p>
            <ul>
              <li>
                Customer Care: +603 2332 6000 (Domestic) or +603 2332 9000
                (International).
              </li>
              <li>Fax No: +603 2332 6062</li>
              <li>
                Click Email Us or email to{" "}
                <a href="mailto:customersupport@alrajhibank.com.my">
                  customersupport@alrajhibank.com.my
                </a>
              </li>
              <li>Visit any of alrajhi bank Malaysia Branches.</li>
            </ul>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SecurityTips;
